import React from "react";
import { Button, Input } from "reactstrap";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import ContratosTab from "./ContratosTab";
import { useSelector } from "react-redux";
import { selectValues } from "../../utils/fc";
import CotacoesTab from "./CotacoesTab";
import ModalFormContrForn from "../../components/Modals/ModalFormContrForn/ModalFormContrForn";

const MEUS_CONTRATOS_TAB_INDEX = 1;
const TODOS_OS_CONTRATOS_TAB_INDEX = 2;

const MeusFornecedores = (props) => {
  const [isModalOpen, setIsModalOpen] = React.useState(
    () => new URLSearchParams(window.location.search).get("openAddContractModal") === "1"
  );
  const [selCentroDeCusto, setSelCentroDeCusto] = React.useState([]);
  const [globalSelectedCc, setGlobalSelectedCc] = React.useState("");
  const [forceRender, setForceRender] = React.useState(0);
  const [editingContrFornId, setEditingContrFornId] = React.useState(null);
  const [isModalPedidoCompraOpen, setIsModalPedidoCompraOpen] = React.useState(false);
  const [isModalPedidoCotacaoOpen, setIsModalPedidoCotacaoOpen] = React.useState(false);
  const initialUrlContrFornId = React.useMemo(() => {
    return new URLSearchParams(window.location.search).get("contrFornId");
  }, []);
  const { user } = useSelector((state) => state.auth);

  const canSeeAllContracts = (
    user.perm_id === 1
    || Number(user.pf_id) === 104
    || Number(user.pf_id) === Number(props.proj_coord)
  );
  const expandTargetTabIndex = canSeeAllContracts
    ? TODOS_OS_CONTRATOS_TAB_INDEX
    : MEUS_CONTRATOS_TAB_INDEX;
  const hasInitialExpand = Boolean(initialUrlContrFornId || props.expandContrFornId);
  const [selectedTab, setSelectedTab] = React.useState(() => (
    hasInitialExpand ? expandTargetTabIndex : 0
  ));
  const [expandContrFornId, setExpandContrFornId] = React.useState(() => (
    props.expandContrFornId != null
      ? String(props.expandContrFornId)
      : (initialUrlContrFornId || null)
  ));
  const [expandCompraCotacaoId, setExpandCompraCotacaoId] = React.useState(() => (
    props.expandCompraCotacaoId != null ? String(props.expandCompraCotacaoId) : null
  ));
  const [expandContrFornRequestKey, setExpandContrFornRequestKey] = React.useState(0);
  const pedidosCotacaoTabIndex = 0;
  const pedidosTabIndex = 0; // era 1; aba Cotações oculta

  const addContractOrcItemId = React.useMemo(() => {
    const orcItemId = new URLSearchParams(window.location.search).get("orcItem_id");
    return orcItemId ? Number(orcItemId) : null;
  }, []);

  React.useEffect(() => {
    fetchCentroDeCustoForSelect();
  }, []);

  React.useEffect(() => {
    if (props.expandContrFornId == null || props.expandContrFornId === "") return;
    const nextId = String(props.expandContrFornId);
    setGlobalSelectedCc("");
    setExpandContrFornId(nextId);
    setExpandCompraCotacaoId(
      props.expandCompraCotacaoId != null ? String(props.expandCompraCotacaoId) : null
    );
    setExpandContrFornRequestKey((prev) => prev + 1);
    setForceRender((prev) => prev + 1);
    setSelectedTab(expandTargetTabIndex);
  }, [props.expandContrFornId, props.expandCompraCotacaoId, props.expandContrFornRequestKey, expandTargetTabIndex]);

  const fetchCentroDeCustoForSelect = async () => {
    try {
      const res = await selectValues("orcRubr", "orcRubr_id", "orcRubr_nome", {
        orcRubr_ativo: 1,
        orcRubr_mae: "!IN!(1, 2)",
      });

      setSelCentroDeCusto(
        res.sort((a, b) => {
          if (a.label < b.label) return -1;
          if (a.label > b.label) return 1;
          return 0;
        })
      );
    } catch (error) {
      console.error("Error fetching centro de custo:", error);
    }
  };

  const handleEditDraft = (contrFornId) => {
    setEditingContrFornId(contrFornId);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setEditingContrFornId(null);
  };

  const handleOpenNewContract = () => {
    setEditingContrFornId(null);
    setIsModalOpen(true);
  };

  const handleOpenContrForn = React.useCallback((contrFornId, { compraCotacaoId } = {}) => {
    if (!contrFornId) return;
    setGlobalSelectedCc("");
    setExpandContrFornId(String(contrFornId));
    setExpandCompraCotacaoId(compraCotacaoId != null ? String(compraCotacaoId) : null);
    setExpandContrFornRequestKey((prev) => prev + 1);
    setForceRender((prev) => prev + 1);
    setSelectedTab(expandTargetTabIndex);
  }, [expandTargetTabIndex]);

  return (
    <>
      <Tabs selectedIndex={selectedTab} onSelect={setSelectedTab}>
        <TabList>
          <div className="d-flex justify-content-between align-items-center">
            <div>
              {/* <Tab>Cotações</Tab> */}
              <Tab>Cotações</Tab>
              <Tab>Meus Contratos</Tab>
              {canSeeAllContracts && (
                <Tab>Todos os Contratos</Tab>
              )}
            </div>
            {selectedTab !== pedidosTabIndex && (
              <div className="d-flex align-items-center gap-2">
                <div style={{ minWidth: "250px" }}>
                  <Input
                    type="select"
                    value={globalSelectedCc}
                    onChange={(e) =>
                      setGlobalSelectedCc(e.target.value ? Number(e.target.value) : "")
                    }
                  >
                    <option value="">Filtrar por Centro de Custo...</option>
                    {selCentroDeCusto.map((cc) => (
                      <option key={cc.value} value={cc.value}>
                        {cc.label}
                      </option>
                    ))}
                  </Input>
                </div>
                <Button style={{ height: "2.5rem" }} onClick={handleOpenNewContract}>
                  Adicionar contrato
                </Button>
              </div>
            )}
          </div>
        </TabList>

        {/* <TabPanel>
          <CotacoesTab
            onlyPedidoCotacao
            isActive={selectedTab === pedidosCotacaoTabIndex}
            isModalOpen={isModalPedidoCotacaoOpen}
            setIsModalOpen={setIsModalPedidoCotacaoOpen}
          />
        </TabPanel> */}
        <TabPanel>
          <CotacoesTab
            isActive={selectedTab === pedidosTabIndex}
            isModalOpen={isModalPedidoCompraOpen}
            setIsModalOpen={setIsModalPedidoCompraOpen}
            onOpenContrForn={handleOpenContrForn}
            proj_orcRubrId={props.proj_orcRubrId}
          />
        </TabPanel>
        <TabPanel>
          <ContratosTab
            forceRender={forceRender}
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            proj_orcRubrId={props.proj_orcRubrId}
            proj_coord={props.proj_coord}
            handleEditDraft={handleEditDraft}
            filterMeusFornecedores={true}
            selectedCcId={globalSelectedCc}
            selCentroDeCusto={selCentroDeCusto}
            expandContrFornId={selectedTab === MEUS_CONTRATOS_TAB_INDEX ? expandContrFornId : null}
            expandCompraCotacaoId={selectedTab === MEUS_CONTRATOS_TAB_INDEX ? expandCompraCotacaoId : null}
            expandContrFornRequestKey={expandContrFornRequestKey}
          />
        </TabPanel>
        {canSeeAllContracts && (
          <TabPanel>
            <ContratosTab
              forceRender={forceRender}
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              proj_orcRubrId={props.proj_orcRubrId}
              proj_coord={props.proj_coord}
              handleEditDraft={handleEditDraft}
              filterMeusFornecedores={false}
              selectedCcId={globalSelectedCc}
              selCentroDeCusto={selCentroDeCusto}
              expandContrFornId={selectedTab === TODOS_OS_CONTRATOS_TAB_INDEX ? expandContrFornId : null}
              expandCompraCotacaoId={selectedTab === TODOS_OS_CONTRATOS_TAB_INDEX ? expandCompraCotacaoId : null}
              expandContrFornRequestKey={expandContrFornRequestKey}
            />
          </TabPanel>
        )}
      </Tabs>

      <ModalFormContrForn
        standalone
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        hideTrigger
        modalTitle="Cadastro de contrato de fornecedor"
        proj_orcRubrId={props.proj_orcRubrId}
        pedidoCompraData={
          addContractOrcItemId ? { orcItem_id: addContractOrcItemId } : undefined
        }
        contrFornData={
          editingContrFornId ? { contrForn_id: editingContrFornId } : undefined
        }
        loadExistingContrFornOnOpen={!!editingContrFornId}
        onSuccess={() => setForceRender((prev) => prev + 1)}
      />
    </>
  );
};

export default MeusFornecedores;
